export const initialState = {
  ExploreList: []
};
